import { onRequest } from '../..';
import { ActionsType, PropertyType } from '../../../common';
import { findIndex } from 'lodash';
import { addNewGameCategory } from '../../../api/endpoints/addNewGameCategory';
import { validateForm } from '../../../view/pages/GameCategories/GameCategoires.helper';
import { getCasinoGameCategory } from '../../../api/endpoints/getCasinoGameCategory';
import { editGameCategory } from '../../../api/endpoints/editGameCategory';
import { getCasinoGameCategories } from '../../../api/endpoints/getCasinoGameCategories';
import { GameCategoryFormKey } from '../../../view/pages/GameCategories/GameCategories.const';

const gameCategoriesInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { gameCategories, pagesTotal } = await getCasinoGameCategories({ token, page, query: '', perPage });
	return { gameCategories: gameCategories, bulkRows: [], pagesTotal, currentPage: page, gamesLoading: false };
};

const gameCategoryInit = async (state: PropertyType, payload: PropertyType) => {
	const { token, id } = payload;
	const { gameCategory } = await getCasinoGameCategory({ token, id });

	const gameCategoriesData = {
		game_name: gameCategory.name,
		game_id: gameCategory.id,
	};

	return { gamesLoading: false, gameCategoryForm: gameCategoriesData };
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { gameCategories, pagesTotal } = await getCasinoGameCategories({ token, page, query: '', perPage });
	return { gameCategories: gameCategories, bulkRows: [], pagesTotal, currentPage: page, gamesLoading: false };
};
//
// const onGameToggle = async (payload: PropertyType) => {
// 	const { token, page } = payload;
// 	const data = await getCasinoGames({ token, page, query: '' });
//
// 	return { data };
// };
//
// const onUpdateCategoryForm = (state: PropertyType, payload: PropertyType) => {
// 	const { categories } = payload;
// 	return { categoryForm: { categories: categories } };
// };

const formReset = () => {
	return {
		gameFormCategory: {
			game_name: '',
		},
	};
};
//
const onGameCategoryAdd = async (state: PropertyType, payload: PropertyType) => {
	const { token, gameCategoryForm } = payload;
	const formErrors = validateForm(gameCategoryForm);
	const gameCategories = [...state.gameCategories];
	let responesMsg = '';
	if (formErrors) {
		return { formErrors };
	} else {
		if (state?.selectedGameCategory?.id) {
			const { gameCategory, message } = await editGameCategory({
				token,
				gameCategoryForm: { ...gameCategoryForm, game_id: state.selectedGameCategory.id },
			});
			responesMsg = message;
			const editIndex = findIndex(gameCategories, ['game_id', state.selectedGameCategory.id]);
			gameCategories[editIndex] = gameCategory;
		} else {
			// const { gameCategory, message } = await addNewGameCategory({ token, gameCategoryForm });
			const { message } = await addNewGameCategory({ token, gameCategoryForm });
			responesMsg = message;
			// gameCategories.unshift(gameCategory);
		}
		return {
			globalSuccess: responesMsg,
			gameCategories,
		};
	}
};

const onUpdateForm = (state: PropertyType, payload: PropertyType) => {
	const { field, value } = payload;
	const newForm = { ...state.gameCategoryForm, [field]: value };
	const errors = validateForm(newForm);
	const fieldError = errors ? errors[field as GameCategoryFormKey] : null;

	return {
		gameCategoryForm: newForm,
		formErrors: { ...state.formErrors, [field]: fieldError },
	};
};

// const onGameTCategory = async (payload: PropertyType) => {
// 	const { token, filters } = payload;
// 	const resp = await getFilterOptions({ token, filters });
//
// 	return { ...resp.data };
// };
//
const onGameCategorySelect = async (payload: PropertyType) => {
	const { gameCategory } = payload;

	return {
		selectedGameCategory: gameCategory,
		gameCategoryForm: {
			game_name: '',
		},
	};
};

export const actions: ActionsType = {
	GAME_CATEGORIES_INIT: (state, payload) => onRequest(() => gameCategoriesInit(payload), true),
	GAME_CATEGORY_INIT: (state, payload) => gameCategoryInit(state, payload),
	LOADING: (state, payload) => ({ gamesLoading: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	SELECT_GAME_CATEGORY: (state, payload) => onGameCategorySelect(payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	GAME_CATEGORY_ADD: (state, payload) => onGameCategoryAdd(state, payload),
	FORM: (state, payload) => onUpdateForm(state, payload),
	FORM_RESET: () => formReset(),
	SAVING: (state, payload) => ({ savingData: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', formErrors: '', usersLoading: false }),
};
